import React from "react";
import { CheckCircle, Battery, Wifi, TrendingUp } from "lucide-react";
import "./DevicesSection.css"; // We'll create this CSS file

const devicesData = [
  {
    name: "Smart Heart Monitor",
    image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=300&fit=crop",
    features: ["24/7 ECG monitoring", "Arrhythmia detection", "Wireless connectivity"],
    specs: { battery: "7 days", connectivity: "5G/WiFi", accuracy: "99.5%" }
  },
  {
    name: "Blood Pressure Cuff",
    image: "https://images.unsplash.com/photo-1584362917165-526a968579e8?w=400&h=300&fit=crop",
    features: ["Automatic measurements", "Trend analysis", "Mobile app sync"],
    specs: { battery: "30 days", connectivity: "Bluetooth", accuracy: "98.8%" }
  },
  {
    name: "Pulse Oximeter",
    image: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400&h=300&fit=crop",
    features: ["SpO2 & pulse rate", "Sleep monitoring", "Real-time alerts"],
    specs: { battery: "14 days", connectivity: "WiFi", accuracy: "99.2%" }
  }
];

const DevicesSection = () => {
  return (
    <section className="md-devices-section" id="devices">
      <div className="md-container">
        <div className="md-section-header">
          <h2>Advanced IoT Medical Devices</h2>
          <p>
            Our cutting-edge sensors and devices provide accurate, continuous monitoring with seamless connectivity.
          </p>
        </div>

        <div className="md-devices-grid">
          {devicesData.map((device, index) => (
            <div key={device.name} className="md-device-card">
              <img src={device.image} alt={device.name} className="md-device-image" />
              <h3>{device.name}</h3>
              <ul className="md-features-list">
                {device.features.map((feature, i) => (
                  <li key={i}>
                    <CheckCircle className="md-icon" />
                    {feature}
                  </li>
                ))}
              </ul>
              <div className="md-specs">
                <div>
                  <Battery className="md-icon" />
                  <span>{device.specs.battery}</span>
                </div>
                <div>
                  <Wifi className="md-icon" />
                  <span>{device.specs.connectivity}</span>
                </div>
                <div>
                  <TrendingUp className="md-icon" />
                  <span>{device.specs.accuracy}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DevicesSection;
